
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11.9998 3C11.5398 3 11.0698 3.04 10.5998 3.14C7.83983 3.67 5.63983 5.9 5.11983 8.66C4.63983 11.27 5.59983 13.67 7.33983 15.22C7.76983 15.6 7.99983 16.13 7.99983 16.69V19C7.99983 20.1 8.89983 21 9.99983 21H10.2798C10.6298 21.6 11.2598 22 11.9998 22C12.7398 22 13.3798 21.6 13.7198 21H13.9998C15.0998 21 15.9998 20.1 15.9998 19V16.69C15.9998 16.14 16.2198 15.6 16.6398 15.23C18.0898 13.95 18.9998 12.08 18.9998 10C18.9998 6.13 15.8698 3 11.9998 3ZM12.4998 14H11.4998V11.41L9.66983 9.59L10.3798 8.88L11.9998 10.5L13.6198 8.88L14.3298 9.59L12.4998 11.42V14ZM13.4998 19C13.4898 19 13.4798 18.99 13.4698 18.99V19H10.5298V18.99C10.5198 18.99 10.5098 19 10.4998 19C10.2198 19 9.99983 18.78 9.99983 18.5C9.99983 18.22 10.2198 18 10.4998 18C10.5098 18 10.5198 18.01 10.5298 18.01V18H13.4698V18.01C13.4798 18.01 13.4898 18 13.4998 18C13.7798 18 13.9998 18.22 13.9998 18.5C13.9998 18.78 13.7798 19 13.4998 19ZM13.4998 17H10.4998C10.2198 17 9.99983 16.78 9.99983 16.5C9.99983 16.22 10.2198 16 10.4998 16H13.4998C13.7798 16 13.9998 16.22 13.9998 16.5C13.9998 16.78 13.7798 17 13.4998 17Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-emoji-objects`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconEmojiObjects

    ```js
    <b-new-b-icon-emoji-objects />
    ```
</docs>


